export const kmLabels = {
    "global" : {
        "empty_value_indicator" : "-"
    },
    "documents" : {
        "draft" : "Wersja robocza",
        "published" : "Opublikowany"
    },
    "user_permissions" : {
        "read_access" : "Odczyt",
        "voting" : "Głosowanie",
        "user_admin" : "Administracja"
    }
}